








































//@ts-nocheck
import { Store } from "@/libs/Store";
import Vue from "vue";
import Api from "@/libs/Api";
import axios from "axios";
import { Config } from "@/libs/Config";

export default Vue.extend({
  data() {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      innerLoop: false,
      loaded: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100,
      forwardRewindTimeout: undefined as number | undefined,
      rewindTimeout: undefined as number | undefined,
    };
  },
  props: {
    file: {
      type: String,
      default: null,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  } as any,
  methods: {
    startForwardRewind: function () {
      console.log("forward")

        this.audio.currentTime += 5;
    },
    stopForwardRewind: function () {
      console.log("stop forward")
      clearInterval(this.forwardRewindTimeout);
    },
    startRewind: function () {
      

        this.audio.currentTime -= 5;
    },
    stopRewind: function () {
      
      clearInterval(this.rewindTimeout);
    },
    convertTimeHHMMSS(val: any) {
      let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

      return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
    },
    download() {
      //@ts-ignore
      this.stop();
      //@ts-ignore
      window.open(this.file, "download");
    },
    load() {
      //@ts-ignore
      if (this.audio.readyState >= 2) {
        //@ts-ignore
        this.loaded = true;
        //@ts-ignore
        this.durationSeconds = parseInt(this.audio.duration);
        //@ts-ignore
        return (this.playing = this.autoPlay);
      }

      throw new Error("Failed to load sound file.");
    },
    mute() {
      //@ts-ignore
      if (this.muted) {
        //@ts-ignore
        return (this.volume = this.previousVolume);
      }

      //@ts-ignore
      this.previousVolume = this.volume;
      //@ts-ignore
      this.volume = 0;
    },
    seek(e: any) {
      //@ts-ignore
      if (!this.playing || e.target.tagName === "SPAN") {
        return;
      }

      const el = document
        .getElementById("progress-bar")
        ?.getBoundingClientRect();
      if (!el) return;
      console.log(el);
      console.log(e);
      const seekPos = (e.clientX - el.left) / el.width;
      console.log(seekPos);
      //@ts-ignore
      this.audio.currentTime = parseFloat(this.audio.duration * seekPos);
    },
    stop() {
      //@ts-ignore
      this.playing = false;
      //@ts-ignore
      this.audio.currentTime = 0;
    },
    update(e: any) {
      //@ts-ignore
      this.currentSeconds = parseFloat(this.audio.currentTime);
    },
  },

  computed: {
    currentTime() {
      //@ts-ignore
      return this.convertTimeHHMMSS(this.currentSeconds);
    },
    durationTime() {
      //@ts-ignore
      return this.convertTimeHHMMSS(this.durationSeconds);
    },
    percentComplete() {
      //@ts-ignore
      return parseInt((this.currentSeconds / this.durationSeconds) * 100);
    },
    muted() {
      //@ts-ignore
      return this.volume / 100 === 0;
    },
  },
  created() {
    //@ts-ignore
    this.innerLoop = this.loop;
  },
  mounted() {
    var self = this;
    //@ts-ignore
    this.audio = this.$el.querySelectorAll("audio")[0];
    console.log("audio");
    //@ts-ignore
    console.log(this.audio);
    // addEventListener('touchstart', function (e) {
    //     //@ts-ignore
    //     self.audio.play();
    //     //@ts-ignore
    //     self.audio.pause();
    // });

    //@ts-ignore
    this.audio.load();
    //@ts-ignore
    this.audio.play();

    //@ts-ignore
    this.audio.addEventListener("timeupdate", this.update);
    //@ts-ignore
    this.audio.addEventListener("loadeddata", this.load);
    //@ts-ignore
    this.audio.addEventListener("pause", () => {
      //@ts-ignore
      this.playing = false;
    });
    //@ts-ignore
    this.audio.addEventListener("play", () => {
      //@ts-ignore
      this.playing = true;
    });
  },
  watch: {
    playing(value) {
      if (value) {
        //@ts-ignore
        return this.audio.play();
      }
      //@ts-ignore
      this.audio.pause();
    },
    volume(value) {
      //@ts-ignore
      this.showVolume = false;
      //@ts-ignore
      this.audio.volume = this.volume / 100;
    },
  },
});
